/**
 * Sala/ambiente da escola (tabela `Sala`). Ver docs/salas-ambientes/README.md.
 *
 * A API omite as propriedades nulas do JSON — por isso tudo o que pode faltar é opcional e a tela
 * testa `null` E `undefined` (`== null`).
 */
export class SalaModel {
  gesSalaId?: number = 0;
  gesEscolaId?: number = 0;
  /** Identificação (`NUMERO`, até 5 caracteres). */
  numero?: string = '';
  /** Localização (`BLOCO`, texto livre até 50: bloco, andar, ala). */
  bloco?: string = '';
  /** Tipo de ambiente — a "função original" da sala (tabela da rede). */
  gesFuncaoOriginalId?: number | null = null;
  /** Utilização atual (tabela da rede). */
  gesUtilizacaoId?: number | null = null;
  /** Forma de ocupação: 1 Próprio, 2 Alugado, 3 Cedido, 4 Compartilhado. */
  formaOcupacao?: number | null = null;
  /** Área em m², até duas casas decimais. */
  area?: number | null = null;
  /** Coeficiente de ALUNOS por m², até quatro casas decimais. */
  coeficienteAlunoM2?: number | null = null;
  /** Capacidade de alunos (`CAPAC`). */
  capacidade?: number | null = null;
  /** A capacidade foi digitada e não é recalculada quando a área ou o coeficiente mudam. */
  capacidadeAjusteManual?: boolean = false;
  /** Só na leitura: piso(área × coeficiente), quando há os dois. */
  capacidadeCalculada?: number | null;
  capacidadeReal?: number | null = null;
  recebeTurma?: number = 1;
  requerAdequacao?: number = 0;
  ativo?: number = 1;

  // Só na listagem
  funcaoOriginalSala?: string;
  utilizacaoSala?: string;
  formaOcupacaoDescricao?: string;
}

/** Um documento anexado ao ambiente. */
export interface AnexoSalaModel {
  codigo: number;
  salaId: number;
  descricao: string;
  tipoDocumento: number;
  tipoDocumentoDescricao: string;
  dataDocumento: string;
  nomeArquivo: string;
  tipoConteudo: string;
  tamanho: number;
  dataInclusao: string;
  nomeUsuario?: string;
  /** Link temporário (SAS) do arquivo; ausente quando o arquivo não está mais no Storage. */
  url?: string;
}

export interface ListasSalaModel {
  formasOcupacao: { valor: number; texto: string }[];
  tiposDocumento: { valor: number; texto: string }[];
}
